import cloneDeep from 'lodash.clonedeep';

export default function setActiveSceneReducer(state, action) {
  const { scribeId, sceneId } = action;
  const scribe = state.allScribes.find(s => s.id === scribeId);

  if (scribe) {
    const updatedScribe = cloneDeep(scribe);
    const isSceneInScribe = updatedScribe.scenes.find(sc => sc.id === sceneId);

    if (isSceneInScribe) {
      updatedScribe.scenes.forEach(scene => {
        scene.active = scene.id === sceneId;
      });

      const updatedAllScribes = [...state.allScribes];
      const replacementIndex = updatedAllScribes.findIndex(s => s.id === updatedScribe.id);
      updatedAllScribes[replacementIndex] = updatedScribe;

      return {
        ...state,
        allScribes: updatedAllScribes,
        selectedSceneIds: [sceneId],
        activeElements: []
      };
    }
  }

  return state;
}
